/**
 * default headers if no headers has been passed
 */
export const API_HEADERS_COMMON_CONFIG = {
  "x-api-key": process.env.REACT_APP_SECRET_API_KEY,
};

/**
 * default headers if no headers has been passed for static api
 */
export const API_HEADERS_COMMON_CONFIG_STATIC = {
  "x-api-key": process.env.REACT_APP_SECRET_STATIC_API_KEY,
};

/**
 * default headers if no headers has been passed for promotion-manager
 */
export const API_HEADERS_COMMON_PROMOTION_MANAGER = {
  "x-api-key": process.env.REACT_APP_SECRET_PROMOTION_MANAGER_API_KEY,
};